webpackJsonp([1],{

/***/ 760:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var builder_1 = __webpack_require__(75);
var shared_module_1 = __webpack_require__(158);
var routing_1 = __webpack_require__(776);
var overview_1 = __webpack_require__(768);
var fylke_1 = __webpack_require__(767);
var types_1 = __webpack_require__(777);
var FylkerModule = (function () {
    function FylkerModule(self, builder) {
        this.builder = builder;
        if (self) {
            throw new Error('ProfModule is already loaded.');
        }
        else {
            builder.mapComponent('node', {
                recipe_cat: {
                    type: types_1.Fylke
                }
            });
        }
    }
    FylkerModule = __decorate([
        core_1.NgModule({
            imports: [
                shared_module_1.SharedModule,
                routing_1.FylkerRoutingModule
            ],
            declarations: [
                overview_1.FylkerOverviewPage,
                fylke_1.FylkePage
            ]
        }),
        __param(0, core_1.Optional()),
        __param(0, core_1.SkipSelf()), 
        __metadata('design:paramtypes', [FylkerModule, (typeof (_a = typeof builder_1.o7BuilderService !== 'undefined' && builder_1.o7BuilderService) === 'function' && _a) || Object])
    ], FylkerModule);
    return FylkerModule;
    var _a;
}());
exports.FylkerModule = FylkerModule;


/***/ }),

/***/ 767:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var platform_browser_1 = __webpack_require__(15);
var platform_browser_2 = __webpack_require__(15);
var router_1 = __webpack_require__(30);
var node_resource_1 = __webpack_require__(62);
var o7SEO_1 = __webpack_require__(63);
var utils_1 = __webpack_require__(32);
var FylkePage = (function () {
    function FylkePage(document, route, router, nodeService, sanitizer, seoService, events) {
        var _this = this;
        this.document = document;
        this.route = route;
        this.router = router;
        this.nodeService = nodeService;
        this.sanitizer = sanitizer;
        this.seoService = seoService;
        this.events = events;
        this.children = [];
        this.results = [];
        this.perPage = 9;
        this.curP = 1;
        this.max = 0;
        this.loading = 0;
        this.events.emit('loading-toggle', 1);
        this.route.params.subscribe(function (params) {
            _this.url = params['fylke'];
            _this.nodeService.getNodeBySlug$('fylker/' + _this.url).subscribe(function (node) {
                if (node && node._entitytype !== 'error') {
                    _this.node = node;
                    var url = 'http://lorempixel.com/g/1160/655/food?' + Date.now();
                    if (node.background_image) {
                        url = node.background_image.src;
                    }
                    _this.background = _this.sanitizer.bypassSecurityTrustStyle("linear-gradient(180deg, rgba(0, 0, 0, .5), rgba(0, 0, 0, .5)), url(" + url + ")");
                    if (node.group_image) {
                        var link = node.background_image.getStyle('landscape');
                        _this.group_background = _this.sanitizer.bypassSecurityTrustStyle("linear-gradient(180deg, rgba(0, 0, 0, .5), rgba(0, 0, 0, .5)), url(" + link + ")");
                    }
                    if (node.children) {
                        _this.results = [];
                        _this.children = node.children;
                        _this.page(1);
                    }
                    _this.seoService.update(_this.node);
                }
                else {
                    _this.router.navigate(['/404']);
                }
                _this.events.emit('loading-toggle', 0);
            }, function (error) {
                _this.router.navigate(['/404']);
                _this.events.emit('loading-toggle', 0);
            });
        });
    }
    FylkePage.prototype.ngAfterViewInit = function () {
        this.el.nativeElement.style.backgroundImage = "url(/assets/fylker/" + this.url + ".png)";
        this.el.nativeElement.style.backgroundPosition = "center calc(50% + 40px)";
    };
    FylkePage.prototype.onWindowScroll = function () {
        if (typeof window !== 'undefined') {
            if (window.scrollY > 1028)
                return;
            if (window.scrollY > 5) {
                var pixels = 40 + (window.scrollY / 4);
                this.el.nativeElement.style.backgroundImage = "url(/assets/fylker/" + this.url + ".png)";
                this.el.nativeElement.style.backgroundPosition = "center calc(50% + " + pixels + "px)";
            }
            else {
                this.el.nativeElement.style.backgroundImage = "url(/assets/fylker/" + this.url + ".png)";
                this.el.nativeElement.style.backgroundPosition = "center calc(50% + 40px)";
            }
        }
    };
    FylkePage.prototype.page = function (_pnum) {
        var _this = this;
        this.curP = _pnum;
        this.max = this.curP * this.perPage;
        var start = (this.curP - 1) * this.perPage;
        this.total = this.children.length;
        this.max = this.max >= this.total ? this.total : this.max;
        var _loop_1 = function(i) {
            this_1.loading++;
            this_1.nodeService.loadById$(this_1.children[i]).subscribe(function (node) {
                if (node)
                    _this.results[i] = node;
                _this.loading--;
            });
        };
        var this_1 = this;
        for (var i = start; i < this.max; i++) {
            _loop_1(i);
        }
    };
    __decorate([
        core_1.ViewChild('backdrop'), 
        __metadata('design:type', (typeof (_a = typeof core_1.ElementRef !== 'undefined' && core_1.ElementRef) === 'function' && _a) || Object)
    ], FylkePage.prototype, "el", void 0);
    __decorate([
        core_1.HostListener("window:scroll", []), 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', []), 
        __metadata('design:returntype', void 0)
    ], FylkePage.prototype, "onWindowScroll", null);
    FylkePage = __decorate([
        core_1.Component({
            styles: [__webpack_require__(786)],
            template: __webpack_require__(792)
        }),
        __param(0, core_1.Inject(platform_browser_1.DOCUMENT)), 
        __metadata('design:paramtypes', [Object, (typeof (_b = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof node_resource_1.o7NodeService !== 'undefined' && node_resource_1.o7NodeService) === 'function' && _d) || Object, (typeof (_e = typeof platform_browser_2.DomSanitizer !== 'undefined' && platform_browser_2.DomSanitizer) === 'function' && _e) || Object, (typeof (_f = typeof o7SEO_1.o7SEOService !== 'undefined' && o7SEO_1.o7SEOService) === 'function' && _f) || Object, (typeof (_g = typeof utils_1.o7EventService !== 'undefined' && utils_1.o7EventService) === 'function' && _g) || Object])
    ], FylkePage);
    return FylkePage;
    var _a, _b, _c, _d, _e, _f, _g;
}());
exports.FylkePage = FylkePage;


/***/ }),

/***/ 768:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var node_resource_1 = __webpack_require__(62);
var utils_1 = __webpack_require__(32);
var FylkerOverviewPage = (function () {
    function FylkerOverviewPage(nodeService, events) {
        var _this = this;
        this.nodeService = nodeService;
        this.events = events;
        this.events.emit("loading-toggle", 1);
        this.nodeService.getNodeBySlug$("fylker").subscribe(function (node) {
            _this.node = node;
            _this.events.emit("loading-toggle", -1);
        });
    }
    FylkerOverviewPage = __decorate([
        core_1.Component({
            template: __webpack_require__(793),
            styles: [__webpack_require__(787)],
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof node_resource_1.o7NodeService !== 'undefined' && node_resource_1.o7NodeService) === 'function' && _a) || Object, (typeof (_b = typeof utils_1.o7EventService !== 'undefined' && utils_1.o7EventService) === 'function' && _b) || Object])
    ], FylkerOverviewPage);
    return FylkerOverviewPage;
    var _a, _b;
}());
exports.FylkerOverviewPage = FylkerOverviewPage;


/***/ }),

/***/ 776:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(30);
var overview_1 = __webpack_require__(768);
var fylke_1 = __webpack_require__(767);
var FylkerRoutingModule = (function () {
    function FylkerRoutingModule() {
    }
    FylkerRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild([
                    { path: '', component: overview_1.FylkerOverviewPage },
                    { path: ':fylke', component: fylke_1.FylkePage }
                ])
            ]
        }), 
        __metadata('design:paramtypes', [])
    ], FylkerRoutingModule);
    return FylkerRoutingModule;
}());
exports.FylkerRoutingModule = FylkerRoutingModule;


/***/ }),

/***/ 777:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var types_1 = __webpack_require__(31);
var Fylke = (function (_super) {
    __extends(Fylke, _super);
    function Fylke(data, entitytype, grouptype, _c) {
        if (entitytype === void 0) { entitytype = 'fylke'; }
        if (grouptype === void 0) { grouptype = 'entity'; }
        if (_c === void 0) { _c = true; }
        _super.call(this, data, entitytype, grouptype, false);
        this.background_image = types_1.Image;
        this.group_image = types_1.Image;
        this.image = types_1.Image;
        if (_c)
            this.construct(data);
    }
    Fylke.prototype.construct = function (data) {
        data.excerpt = data.description;
        _super.prototype.construct.call(this, data);
    };
    return Fylke;
}(types_1.Page));
exports.Fylke = Fylke;
var Fylkeroversikt = (function (_super) {
    __extends(Fylkeroversikt, _super);
    function Fylkeroversikt(data, entitytype, grouptype, _c) {
        if (entitytype === void 0) { entitytype = 'fylkeroversikt'; }
        if (grouptype === void 0) { grouptype = 'entity'; }
        if (_c === void 0) { _c = true; }
        _super.call(this, data, entitytype, grouptype, false);
        this.children = [Fylke];
        if (_c)
            this.construct(data);
    }
    return Fylkeroversikt;
}(types_1.Node));
exports.Fylkeroversikt = Fylkeroversikt;


/***/ }),

/***/ 786:
/***/ (function(module, exports) {

module.exports = ".fylke-page .hero{background-position:0px 0px, 50% 100%;background-size:auto, cover;background-repeat:repeat, no-repeat;position:relative;background-attachment:scroll, fixed}.fylke-page .hero h1{color:#fff;width:100%;text-align:center;font-size:56px;font-size:calc(2.5vw + 2.5vh);line-height:72px;font-weight:700;margin:0;padding-top:5px;padding-bottom:180px}.fylke-page .hero /deep/ .breadcrumb .container{color:#fff}.fylke-page .hero /deep/ .breadcrumb .container a{color:#fff}.fylke-page .backdrop{width:100%;text-align:center;position:relative;padding:0 120px;padding-bottom:80px;background-size:auto;background-repeat:no-repeat;background-position:center calc(50% + 40px)}.fylke-page .backdrop span{font-family:Merriweather, serif;font-size:300px;color:#f4f0ee;display:block;line-height:1;position:absolute;left:0;top:140px;right:0;overflow:hidden;bottom:0;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.fylke-page .backdrop .ingress{position:relative;z-index:100;margin:0px auto;max-width:1200px;display:flex;margin-top:-80px;background-color:#fff;box-shadow:0 26px 29px -12px rgba(0,0,0,0.2)}.fylke-page .backdrop .ingress .image{position:relative;width:50%;background-position:0px 0px;background-size:cover}.fylke-page .backdrop .ingress .content{width:50%;padding:90px 30px 130px;align-self:stretch;text-align:left}.fylke-page .backdrop .ingress .content h3{font-size:25px}.fylke-page .backdrop .ingress .content p{display:block;margin-bottom:20px;font-size:18px;line-height:32px}@media (max-width: 767px){.fylke-page .backdrop .ingress .content{width:100%}.fylke-page .backdrop .ingress .image{display:none}}@media (max-width: 911px){.fylke-page .backdrop{padding-right:20px;padding-left:20px}}.fylke-page .fylker{padding-top:50px;background:#f4f0ee}.fylke-page .fylker .container base-card{display:inline-block;width:33%;min-width:300px;max-width:380px;padding:20px;vertical-align:top}@media (max-width: 991px){.fylke-page .fylker .container base-card{width:49.5%}}@media (max-width: 599px){.fylke-page .fylker .container base-card{display:block;width:100%}}.fylke-page .group{display:flex;min-height:400px;flex-wrap:nowrap}.fylke-page .group .image{display:flex;min-width:50%;padding-top:30px;padding-bottom:30px;justify-content:flex-start;flex:1;background-position:0px 0px, 0px 50%;background-size:auto, cover}@media (max-width: 911px){.fylke-page .group .image{display:none;min-width:100%;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center}}.fylke-page .group .text{position:relative;display:flex;padding:30px;flex-wrap:wrap;align-content:flex-start;flex:1}@media (max-width: 911px){.fylke-page .group .text{min-height:500px;padding-right:10px;padding-left:10px}}.fylke-page .group .text .text-container{display:block;max-width:600px;padding:8px 20px 8px 40px;flex-direction:column;align-items:flex-start;align-self:center;background-color:transparent;text-align:left}.fylke-page .group .text .text-container h3{font-family:'Open Sans', sans-serif;font-weight:600;font-size:25px}.fylke-page .group .text .text-container p{display:block;margin-right:auto;margin-bottom:20px;margin-left:auto;font-size:18px;line-height:32px}.fylke-page .group .text .text-container .read-more{color:#c0392b;position:static;bottom:20px}.fylke-page .group .text .text-container .read-more .fa-external-link{display:inline-block;width:50px;height:50px;margin-right:20px;border:1px solid #c0392b;border-radius:200px;color:#c0392b;line-height:50px;text-align:center;text-decoration:none}.loader{background-repeat:no-repeat;background-position:center;background-size:contain;background-image:url(/assets/searching.gif);height:0px;width:100%;display:block;-webkit-transition-property:height;-moz-transition-property:height;-o-transition-property:height;transition-property:height;-webkit-transition-duration:.15s;-moz-transition-duration:.15s;-o-transition-duration:.15s;transition-duration:.15s;-webkit-transition-timing-function:ease-in;-moz-transition-timing-function:ease-in;-o-transition-timing-function:ease-in;transition-timing-function:ease-in}.loader.active{height:40px}\n"

/***/ }),

/***/ 787:
/***/ (function(module, exports) {

module.exports = ".fylker-overview{background:#f4f0ee;padding:60px 20px 40px}.fylker-overview .flex-container{display:block;text-align:center}.fylker-overview .flex-container .flex-box{text-align:left;display:inline-block;width:33%;min-width:300px;max-width:380px;padding:20px}\n"

/***/ }),

/***/ 792:
/***/ (function(module, exports) {

module.exports = "<div class=\"fylke-page\">\n    <div *ngIf=\"node\" class=\"hero\" [style.background-image]=\"background\">\n        <div class=\"breadcrumb\">\n            <div class=\"container\">\n                <a routerLink=\"/\">Hjem</a> / <a routerLink=\"/fylker\">Fylker</a> / <span class=\"current-page\">{{node.title}}</span>\n            </div>\n        </div>\n        <h1>{{node.title}}</h1>\n    </div>\n    <div class=\"backdrop\" #backdrop>\n        <div class=\"ingress\" *ngIf=\"node && node.content\">\n            <div class=\"content\">\n                <h3>{{node.subtitle}}</h3>\n                <p [innerHTML]=\"node.content\"></p>\n            </div>\n            <div class=\"image\" *ngIf=\"node.image\" [style.background-image]=\"'url(' + node.image.getStyle('ingress_square') + ')'\"></div>\n        </div>\n    </div>\n    <div class=\"fylker\" *ngIf=\"node\">\n        <h2 class=\"styled-title-2\">Mat fra {{node.title}}</h2>\n        <div class=\"container\">\n            <base-card *ngFor=\"let card of results\" [card]=\"card\"></base-card>\n        </div>\n        <div class=\"loader\" [ngClass]=\"{'active': loading > 0}\"></div>\n        <button class=\"load-more-button\" *ngIf=\"loading < 1 && max < total\" (click)=\"page(curP+1)\">Vis flere</button>\n    </div>\n    <div class=\"group\" *ngIf=\"node && node.group_link && node.group_title && node.group_info\">\n        <div class=\"image\" *ngIf=\"node.group_image\" [style.background-image]=\"group_background\"></div>\n        <div class=\"text\">\n            <div class=\"text-container\">\n                <h3 [innerHTML]=\"node.group_title\"></h3>\n                <p [innerHTML]=\"node.group_info\"></p>\n                <a class=\"read-more\" href=\"{{node.group_link}}\" target=\"_blank\">\n                    <i class=\"fa fa-external-link\" aria-hidden=\"true\"></i>Gå til fylkeslag\n                </a>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ 793:
/***/ (function(module, exports) {

module.exports = "<div class=\"breadcrumb\">\n    <div class=\"container\">\n        <a routerLink=\"/\">Hjem</a> / <span class=\"current-page\">Fylker</span>\n    </div>\n</div>\n<div class=\"fylker-overview\">\n    <div class=\"container\" *ngIf=\"node\">\n        <h1 class=\"styled-title-1\">{{node.title}}</h1>\n        <div class=\"flex-container\">\n            <base-card class=\"flex-box\" *ngFor=\"let card of node.children\" [card]=\"card\"></base-card>\n        </div>\n    </div>\n    <div class=\"container\" *ngIf=\"!node\">\n        <h2>loading...</h2>\n    </div>\n</div>"

/***/ })

});


// WEBPACK FOOTER //
// 1.bundle.js